export { default } from "./EmptyResult";